import React from "react";
import { noop } from "@common/helpers/function";
import { TransactionStatus } from "@common/types/transaction";
import { capitalize } from "@common/helpers/string";
import {
    FilterMultiselect,
    FilterMultiselectOption,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { BaseFilterProps } from "../../lib";
import styles from "./TransactionStatusFilter.module.scss";

const options: FilterMultiselectOption[] = Object.values(TransactionStatus).map(
    (status) => ({
        value: status,
        label: capitalize(status),
        searchableLabel: status,
    }),
);

export const TransactionStatusFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const statuses = filters.statuses ?? [];

    return (
        <div className={styles.filter}>
            <FilterMultiselect
                inDropdown={false}
                searchable={false}
                options={options}
                value={statuses}
                onChange={(val) => {
                    onChange({
                        statuses:
                            val.length > 0
                                ? (val as TransactionStatus[])
                                : undefined,
                    });
                }}
                name="statuses"
                onBlur={noop}
            />
        </div>
    );
};
